import { createFormAction } from 'redux-form-saga'
export const FORM_KEY = 'ARTICLE_FORM'
export const ArticleFormAction = createFormAction(FORM_KEY)